import { ProjectService } from '@services/project.service';
import { environment } from '@environments/environment';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'footer-page',
    templateUrl: './footer-page.component.html',
    styleUrls: ['./footer-page.component.scss'],
})
export class FooterPageComponent implements OnInit {

    @Input('footerTitle') FooterTitle: string = "Powerby";

    public Version: string;

    public Author: { Name?: string, Website?: string, Logo: { Footer: string } };

    constructor(private ProjectService: ProjectService) { }

    ngOnInit() {

        const projectSettings = this.ProjectService.GetSettings();

        this.Version = projectSettings?.Project?.Version || '';

        // const exampleVarTranslation = "Boldapps";

        // this.footerTitle = this.footerTitle || $localize`:@@footer.madeBy:Made with ❤️ | ${exampleVarTranslation}`;
        this.Author = environment.Author || { Name: '', Website: '', Logo: null };
        // this.FooterTitle = "Powered by";

    }

}
